<template lang="pug">
  div.my-3
    v-card.py-3(flat)
      v-row.mb-3(no-gutters align="center")
        v-col.px-4.shrink
          y-checkbox.mb-n3.mr-n2(v-model="checkbox" style="height:30px")
        v-col
          div.p2.basic600--text &#35;{{ item.rid || item.lead_rid }} - {{ item.created | convertServerDate }}
      div.px-4
        div.s2.info500--text.mb-1 {{ reseller.first_name }}
        div.s2.basic600--text.mb-1.font-italic {{ getTierName(reseller.tier) }}
        .bank-details(v-if="item.status === 'processed'")
          div.c1.basic700--text.mb-1 BANK : {{ getBankName(item) }}
          div.c1.basic700--text.mb-1 ACCOUNT NAME : {{ item.member.account_name }}
          div.c1.basic700--text.mb-2 ACCOUNT NUMBER : {{ item.member.bank_account }}

        .details.mb-4
          div.c1.basic600--text.mb-1 Commission details:
          div.d-flex.align-end
            template(v-if="totalItems")
              div.c1.primary500--text.mr-6 {{ totalItems }} item{{ totalItems > 1 ? 's' : '' }}
              div.p2.basic600--text {{ item.amount | displayPrice }}
            template(v-else)
              WalletIcon.mr-4(size="20" :style="{ 'color': $vuetify.theme.themes[$theme].primary400 }")
              div.p2.basic600--text {{ item.commission_amount | displayPrice }}
          template(v-if="item.extra_data")
            v-divider.basic300.my-2
            div(v-for="(data, index) in item.extra_data.commissions")
              div.d-flex
                div.c1.primary500--text {{ data.total_units }} x
                div.ml-3
                  div.c2.primary500--text {{ data.product }}
                v-spacer
                div
                  div.c1.primary400--text {{ data.total_amount | displayPrice }}

    v-divider.basic300
</template>

<script>

export default {
  name: 'PayoutItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    companyTiers: {
      type: Array,
      required: true 
    },
    selected: {
      type: Boolean
    },
  },
  data: () => ({
    banks: [
      { code: 'PHBMMYKL', name: 'Affin Bank' },
      { code: 'BPMBMYKL', name: 'Agrobank' },
      { code: 'MFBBMYKL', name: 'Alliance Bank' },
      { code: 'RJHIMYKL', name: 'Al Rajhi Banking' },
      { code: 'ARBKMYKL', name: 'AmBank' },
      { code: 'BIMBMYKL', name: 'Bank Islam' },
      { code: 'BKRMMYKL', name: 'Bank Rakyat' },
      { code: 'BMMBMYKL', name: 'Bank Muamalat' },
      { code: 'BSNAMYK1', name: 'Bank Simpanan Nasional' },
      { code: 'CIBBMYKL', name: 'CIMB' },
      { code: 'CITIMYKL', name: 'Citibank' },
      { code: 'HLBBMYKL', name: 'Hong Leong Bank' },
      { code: 'HBMBMYKL', name: 'HSBC Bank' },
      { code: 'KFHOMYKL', name: 'Kuwait Finance House' },
      { code: 'AFBQMYKL', name: 'MBSB Bank' },
      { code: 'MBBEMYKL', name: 'Maybank' },
      { code: 'OCBCMYKL', name: 'OCBC Bank' },
      { code: 'PBBEMYKL', name: 'Public Bank' },
      { code: 'RHBBMYKL', name: 'RHB Bank' },
      { code: 'SCBLMYKX', name: 'Standard Chartered Bank' },
      { code: 'UOVBMYKL', name: 'United Overseas Bank' }
    ]
  }), 
  computed: {
    reseller() {
      return this.item.member.user
    },
    totalItems() {
      return this.item.extra_data ? this.item.extra_data.commissions.reduce((acc, item) => acc += item.total_units, 0) : null
    },
    checkbox: {
      get () {
        return this.selected
      },
      set (val) {
        if (val) {
          this.$emit('updateData', this.item)
        } else {
          this.$emit('removeData', this.item)
        }
      }
    },
  },
  methods: {
    getTierName(tier) {
      const found = this.companyTiers.find(companyTier => companyTier.id === tier)
      return found ? found.name : null
    },
    getBankName (item) {
      this.banks.filter(f => f.code === item.member?.bank)[0]?.name || null
    }
  },
}
</script>

<style scoped>
</style>